module.exports = __webpack_public_path__ + "img/techhub.510dfb74.png";